import * as type from "../types";
import {get} from "../../config/Requests";
import {setData} from '../helpers';
import {openSnackbarWarning, startLoader,} from "./requestAction";
import t from "../../languages/pl";
import {commonReadAddressRoute, mapCarListRoute} from '../../config/routes';
import instance from "../../config/axiosConfig";
import {tokenIdentifier} from '../../utils/staticData';
import {getToken} from '../../config/sessionData';

export const setSelectedCar = (car) => {
    return (dispatch) => {
        dispatch({
            type: type.SET_SELECTED_CAR,
            value: car
        });
    };
};

export const setCars = (value) => {
    return (dispatch) => {
        dispatch({
            type: type.SET_MAP_CARS,
            value: value
        });
    };
};

export const clearSelectedCar = () => {
    return dispatch => {
        dispatch({
            type: type.SET_SELECTED_CAR,
            value: null
        });
    };
};


//server requests
export const getCarsForMap = (description = "", address) => {

    let params = {
        opis: description,
    };

    if (address) {
        params = {
            ...params,
            ulica: address.street,
            miasto: address.city,
            kod_pocztowy: address.postalCode,
            promien: address.radius
        };
    }

    return (dispatch) => {
        get(
            dispatch,
            mapCarListRoute,
            params,
            response => setData(dispatch, type.SET_MAP_CARS, response)
        );
    };
};

export const addressReveal = id => {
    return (dispatch, getState) => {
        startLoader(dispatch);
        let cars = getState().mapCarsReducer.cars;
        let car = cars.find(car => car.auto_id === id);

        if (!car) {
            return;
        }

        if (car.pozycja_gps === null) {
            openSnackbarWarning(dispatch, t.unableToFindAddressWithoutLocation);
            return;
        }

        let config = {
            headers: {[tokenIdentifier]: getToken()},
            params: {
                lat: car.pozycja_gps.lat,
                lon: car.pozycja_gps.lon
            }
        };
        instance
            .get(commonReadAddressRoute, config)
            .then(response => setAddressForCar(dispatch, cars, car, response.data.adres));
    };
};

//other map actions
export const trackAllCars = () => {
    return (dispatch) => {
        dispatch({
            type: type.TRACK_ALL_CARS
        });
    };
};

const setAddressForCar = (dispatch, cars, car, address) => {
    let newCar = car;
    newCar.adres_gps = address;
    let newCars = cars.map(car => {
        if (car.auto_id === newCar.auto_id)
            return newCar;
        return car;
    });
    dispatch({
        type: type.SET_MAP_CARS,
        value: newCars
    });
};
